export default __webpack_public_path__ + "static/media/doc-icon.a930160e.svg";